/** F606 Webhook Logs page — inbound/outbound integration event log. */
import { Zap } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606WebhookLogsPage() {
  return (
    <F606DataPage
      entity="webhook-logs"
      titleAr="سجل الـ Webhooks"
      titleEn="Webhook logs"
      icon={Zap}
      emptyIcon={Zap}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        {
          key: 'event',
          ar: 'الحدث', en: 'Event',
          render: (r) => (
            <div>
              <div className="font-bold text-white font-mono text-[11px]">{r.event || r.event_type || '—'}</div>
              {r.source && <div className="text-[10px] text-white/40">{r.source}</div>}
            </div>
          ),
        },
        { key: 'direction', ar: 'الاتجاه', en: 'Direction', render: (r) => (
          <span className={`inline-flex px-1.5 py-0.5 rounded text-[10px] font-bold ${
            r.direction === 'outbound' ? 'bg-sky-500/15 text-sky-300' : 'bg-purple-500/15 text-purple-300'
          }`}>
            {r.direction || 'inbound'}
          </span>
        ), className: 'w-24' },
        {
          key: 'status',
          ar: 'الحالة', en: 'Status',
          render: (r) => {
            const code = Number(r.status_code || r.status || 0);
            const ok = code >= 200 && code < 400;
            return (
              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold font-mono border ${
                ok ? 'bg-emerald-500/15 border-emerald-500/40 text-emerald-300' : 'bg-red-500/15 border-red-500/40 text-red-300'
              }`}>
                {r.status_code || r.status || '—'}
              </span>
            );
          },
          className: 'w-24',
        },
        { key: 'duration_ms', ar: 'المدة', en: 'Duration', render: (r) => r.duration_ms != null ? <span className="font-mono text-[11px] text-white/60" dir="ltr">{r.duration_ms}ms</span> : '—', className: 'w-24' },
        {
          key: 'created_at',
          ar: 'التاريخ', en: 'When',
          render: (r) => r.created_at ? new Date(r.created_at).toLocaleString() : '—',
          className: 'w-40 text-[11px] text-white/60',
        },
      ]}
    />
  );
}
